RivalIQ.apps.Insights.module('widgets', function (widgets, App, Backbone, Marionette, $, _) {

    'use strict';

    const FbPostDetailsReachView = widgets.PostDetailsColumnView.extend({
        columnWidth: 4,

        className: 'facebook-insights-post-details facebook-insights-post-details-reach',

        loadData: function () {
            const me = this;
            const metric = me.dashboardModel.metric;

            return $.when(metric.create('FACEBOOK_INSIGHTS_POST_NONVIRAL_IMPRESSIONS').fetch(), widgets.PostDetailsColumnView.prototype.loadData.call(me))
                .then(function (nonViralImpressionsMetric) {
                    const nonViralImpressions = nonViralImpressionsMetric.getValue({
                        format: false
                    });

                    // NOTE this logic is duplicated in privateDataSearchServices::createFacebookPostDimension, if you change the logic here change it there to match.
                    if (_.isUndefined(me.isNewPageExperiencePost)) {
                        me.isNewPageExperiencePost = nonViralImpressions < 2 && me.dashboardModel.getCuration().presence.get('has_transitioned_to_new_page_experience');
                        me.refresh();
                    }
                });
        },

        filter: function (widget) {
            const me = this;

            if (widget.newPageExperienceOnly && !me.isNewPageExperiencePost) {
                return false;
            } else if (widget.oldPageExperienceOnly && me.isNewPageExperiencePost) {
                return false;
            }

            return true;
        }
    });

    const FbPostDetailsReachWidget = widgets.PostDetailsWidgetBase.extend({

        title: RivalIQ.strings.facebook_insights_post_detail_reach_and_impressions_title,
        description: RivalIQ.strings.facebook_insights_post_detail_reach_and_impressions_description,
        view: FbPostDetailsReachView,
        panelView: RivalIQ.apps.Dashboard.views.Panel.extend({
            className: 'panel panel-default fb-post-details-impressions-reach'
        }),

        widgetDefinitions: function () {
            const me = this;
            const metric = me.metric;

            return [
                {
                    widgetId: RivalIQ.enums.widgetTypes.METRIC_PIE_CHART_BREAKOUT,
                    metric: metric.create('FACEBOOK_INSIGHTS_POST_TOTAL_REACH'),
                    chart: metric.create('FACEBOOK_INSIGHTS_POST_DETAILS', {
                        submetrics: [
                            'FACEBOOK_INSIGHTS_POST_PAID_REACH',
                            'FACEBOOK_INSIGHTS_POST_ORGANIC_REACH'
                        ],
                        dimensions: ['className']
                    }),
                    newPageExperienceOnly: true
                },
                {
                    widgetId: RivalIQ.enums.widgetTypes.METRIC_PIE_CHART_BREAKOUT,
                    metric: metric.create('FACEBOOK_INSIGHTS_POST_TOTAL_REACH'),
                    chart: metric.create('FACEBOOK_INSIGHTS_POST_DETAILS', {
                        submetrics: [
                            'FACEBOOK_INSIGHTS_POST_PAID_REACH',
                            'FACEBOOK_INSIGHTS_POST_NONVIRAL_REACH',
                            'FACEBOOK_INSIGHTS_POST_VIRAL_REACH'
                        ],
                        dimensions: ['className']
                    }),
                    oldPageExperienceOnly: true
                },
                {
                    widgetId: RivalIQ.enums.widgetTypes.METRIC_PERCENTAGE,
                    title: RivalIQ.strings.facebook_insights_post_detail_reach_and_impressions_organic_fan_reach_title,
                    barTitle: RivalIQ.strings.facebook_insights_post_detail_reach_and_impressions_organic_fan_reach_bar_title,
                    barTitleInfo: RivalIQ.strings.facebook_insights_post_detail_reach_and_impressions_organic_fan_reach_bar_info,
                    metric: metric.create('FACEBOOK_INSIGHTS_POST_FAN_REACH', {
                        name: RivalIQ.strings.facebook_insights_post_detail_reach_and_impressions_organic_fan_reach_title
                    }),
                    divisor: metric.create('FACEBOOK_INSIGHTS_POST_DETAILS', {
                        property: 'page_likes'
                    })
                },
                {
                    widgetId: RivalIQ.enums.widgetTypes.METRIC_PIE_CHART_BREAKOUT,
                    metric: metric.create('FACEBOOK_INSIGHTS_POST_TOTAL_IMPRESSIONS'),
                    chart: metric.create('FACEBOOK_INSIGHTS_POST_DETAILS', {
                        submetrics: [
                            'FACEBOOK_INSIGHTS_POST_PAID_IMPRESSIONS',
                            'FACEBOOK_INSIGHTS_POST_ORGANIC_IMPRESSIONS'
                        ],
                        dimensions: ['className']
                    }),
                    newPageExperienceOnly: true
                },
                {
                    widgetId: RivalIQ.enums.widgetTypes.METRIC_PIE_CHART_BREAKOUT,
                    metric: metric.create('FACEBOOK_INSIGHTS_POST_TOTAL_IMPRESSIONS'),
                    chart: metric.create('FACEBOOK_INSIGHTS_POST_DETAILS', {
                        submetrics: [
                            'FACEBOOK_INSIGHTS_POST_PAID_IMPRESSIONS',
                            'FACEBOOK_INSIGHTS_POST_NONVIRAL_IMPRESSIONS',
                            'FACEBOOK_INSIGHTS_POST_VIRAL_IMPRESSIONS'
                        ],
                        dimensions: ['className']
                    }),
                    oldPageExperienceOnly: true
                }
            ];
        }
    });

    Marionette.Dashboard.widgets.add(RivalIQ.enums.widgetTypes.FB_INISGHTS_POST_REACH_AND_IMPRESSIONS, FbPostDetailsReachWidget);

});
